import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { LaborGuideItem } from './labor-guide-item';

@Directive({
  selector: '[appMyLabortree]'
})
export class MyLabortreeDirective {
  @Input() laborItems: LaborGuideItem[];
  @Input() laborId: number;
  isClicked: boolean = false;
  constructor(
    private elRef: ElementRef
    , private renderer: Renderer2) {
    // elRef.nativeElement.style.fontWeight = 'bold';
  }

  @HostListener('click') onclick() {
    if (!this.isClicked) {
      this.isClicked = true;
      //get child labors
      let childItems = this.laborItems.filter(a => a['ParentId'] == this.laborId);

      childItems.forEach(element => {
        const div = this.renderer.createElement('div');
        const text = this.renderer.createText(element['Title']);

        this.renderer.setAttribute(div, "class", "childLabor");
        this.renderer.appendChild(div, text);
        this.renderer.appendChild(this.elRef.nativeElement, div);
      });
    }
  }
}
